import React, { useState } from 'react'
import { Row, Col, Button, Card } from "react-bootstrap";
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import * as ModelsWorkflowInbox from '../../models/workflow/WorkflowInbox';
import BorderGrid from '../../common/BorderGrid';
import { ReportTableCustomTableHeader } from 'components/workflow/ReportTableCustomTableHeader';
import { ReportTableCustomTableData } from 'components/workflow/ReportTableCustomTableData';

var imgItem = require('../../assets/image/report-item.png');

type align_ = "left" | "center" | "right";

interface Props {
    isLoading: boolean,
    listDataItem: ModelsWorkflowInbox.DataItem[],
    listCardItem: ModelsWorkflowInbox.CardItem[],
}

interface ModalData {
    label: string,
    value: string
}

interface ReportInfoModalState {
    isToggleModal: boolean,
    tableData?: Array<ModalData>
}

const ReportInformationMobileTable = (props: Props) => {
    const [reportInfoModalData, setReportInfoModalData] = useState<ReportInfoModalState>({ isToggleModal: false });

    const { isLoading, listDataItem, listCardItem } = props;

    const copiedListDataItem = [...listDataItem];
    //console.log("copy list data =", copiedListDataItem)

    let displayTableHeader: ModelsWorkflowInbox.tableheader[] = [];
    let displayTableData: ModelsWorkflowInbox.tabledata[] = [];
    let displayTableDataCustomRow: ModelsWorkflowInbox.tabledata[] = [];

    if (copiedListDataItem[0]?.tabledata[0]?.row?.length > 0) {
        displayTableHeader = copiedListDataItem[0]?.tableheader?.slice(0, 3);
        displayTableData = copiedListDataItem[0]?.tabledata?.map(data => ({ row: data.row?.slice(0, 3) ?? [] }) as ModelsWorkflowInbox.tabledata);
    }

    if (copiedListDataItem[0]?.tabledata[0]?.rowcustom?.length > 0) {
        displayTableHeader = copiedListDataItem[0]?.tableheader;
        displayTableDataCustomRow = copiedListDataItem[0]?.tabledata;
    }

    //console.log("display data tb =", displayTableData)

    const tableFooter = {
        //width: '100%',
        //backgroundColor: '#1473E6',
        //color: '#FFFFFF'
        backgroundColor: '#FAEDC4',
        border: 'none',
        //color: '#FFFFFF'
    };

    //console.log("header =", listDataItem[0].tableheader)
    //console.log("data =", listDataItem[0].tabledata.map(data => data.row))

    function findTableData(index: number): ModalData[] {
        const labelArr = listDataItem[0]?.tableheader.map(header => header.label);
        //console.log("find tb header =", labelArr);

        const tableData = listDataItem[0]?.tabledata[index];
        //console.log("find tb data =", tableData);

        const modalDataArr: Array<ModalData> = [];

        tableData.row.map((row, rowIndex) => {
            modalDataArr.push({
                label: labelArr[rowIndex],
                value: row
            })
        })

        //console.log("renew =", modalDataArr);

        return modalDataArr;
    }

    return (
        <React.Fragment>
            {!isLoading &&
                <div>
                    {listDataItem !== undefined &&
                        listDataItem.length !== 0 &&
                        listDataItem.map((ListItem: ModelsWorkflowInbox.DataItem, idList) => {
                            return (
                                <Row className="mt-3" key={idList}>
                                    <Col>
                                        <Card style={{
                                            borderRadius: '15px',
                                            background: 'none',
                                            border: 'none',
                                        }}
                                        >
                                            <Card.Header
                                                style={{
                                                    backgroundColor: '#FAEDC4',
                                                    border: 'none',
                                                    borderTopLeftRadius: '15px',
                                                    borderTopRightRadius: '15px'
                                                }}
                                            >
                                                <Row>
                                                    <img
                                                        src={imgItem}
                                                        style={{
                                                            marginLeft: '16px',
                                                            marginRight: '16px',
                                                            marginTop: '4px',
                                                            marginBottom: '4px',
                                                            width: '20px',
                                                            height: '20px'
                                                        }}
                                                        alt="file"
                                                    />
                                                    <p style={{
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                        <b>Item Details</b>
                                                    </p>
                                                </Row>
                                            </Card.Header>
                                            <Card.Body
                                                style={{
                                                    border: '1px solid #D9D9D9',
                                                    borderBottomLeftRadius: '15px',
                                                    borderBottomRightRadius: '15px',
                                                    borderTop: 'none'
                                                }}
                                            >
                                                <div style={{ overflowX: "scroll" }}>
                                                    <table className="table table-bordered w-100">
                                                        <thead>
                                                            <tr //className="table-active"
                                                                style={{
                                                                    backgroundColor: '#FAEDC4',
                                                                    //border: 'none',
                                                                    border: '1px solid #D9D9D9',
                                                                }}
                                                            >
                                                                {displayTableHeader.map((data: ModelsWorkflowInbox.tableheader, index) => {
                                                                    return (
                                                                        <ReportTableCustomTableHeader
                                                                            key={index}
                                                                            style={{
                                                                                width: data.width
                                                                                    ? `${data.width}px`
                                                                                    : 'auto',
                                                                                textAlign: data.align as align_,
                                                                            }}
                                                                            styleString={data.style}
                                                                            // colSpan={parseInt(header.attribute?.[0].value ?? 1)}
                                                                            attribute={data.attribute}
                                                                        >
                                                                            {data.label}
                                                                        </ReportTableCustomTableHeader>
                                                                    )
                                                                })}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {displayTableData.map((data: ModelsWorkflowInbox.tabledata, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        {data.row.length > 0 && data.row.map((item: string, index2) => {
                                                                            return (
                                                                                <React.Fragment key={index2}>
                                                                                    <td style={{ textAlign: ListItem.tableheader[index2].align as align_ }}>
                                                                                        {item}
                                                                                    </td>
                                                                                    {index2 === (data.row.length - 1) && (
                                                                                        <td
                                                                                            onClick={() => setReportInfoModalData({ isToggleModal: true, tableData: findTableData(index) })}
                                                                                        >
                                                                                            ...
                                                                                        </td>)}
                                                                                </React.Fragment>
                                                                            )
                                                                        })}
                                                                    </tr>
                                                                )
                                                            })}
                                                            {displayTableDataCustomRow.map((data: ModelsWorkflowInbox.tabledata, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        {data.rowcustom.length > 0 && data.rowcustom.map((item, index2) => {
                                                                            return (
                                                                                <ReportTableCustomTableData
                                                                                    key={index2}
                                                                                    styleString={item.style}
                                                                                    style={{
                                                                                        textAlign: item.align as align_,
                                                                                        width: item.width
                                                                                    }}
                                                                                    attribute={item.attribute}
                                                                                >
                                                                                    {item.label}
                                                                                </ReportTableCustomTableData>
                                                                            )
                                                                        })}
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            )

                        })}

                    {listCardItem != undefined &&
                        listCardItem.length != 0 &&
                        listCardItem.map((listItem: ModelsWorkflowInbox.CardItem, idList) => {
                            return (
                                <Row className="mt-3">
                                    <Col>
                                        <Card style={{
                                            borderRadius: '15px',
                                            background: 'none',
                                            border: 'none',
                                        }}
                                        >
                                            <Card.Header
                                                style={{
                                                    backgroundColor: '#FAEDC4',
                                                    border: 'none',
                                                    borderTopLeftRadius: '15px',
                                                    borderTopRightRadius: '15px'
                                                }}
                                            >
                                                <Row>
                                                    <img
                                                        src={imgItem}
                                                        style={{
                                                            marginLeft: '16px',
                                                            marginRight: '16px',
                                                            marginTop: '4px',
                                                            marginBottom: '4px',
                                                            width: '20px',
                                                            height: '20px'
                                                        }}
                                                        alt="file"
                                                    />
                                                    <p style={{
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                        <b>{listItem.title.label}</b>
                                                    </p>
                                                </Row>
                                            </Card.Header>
                                            <Card.Body
                                                style={{
                                                    border: '1px solid #D9D9D9',
                                                    borderBottomLeftRadius: '15px',
                                                    borderBottomRightRadius: '15px',
                                                    borderTop: 'none'
                                                }}
                                            >
                                                <div className="-mt-3">
                                                    {listItem.ListSubCard.map((cardItem, idx) => (
                                                        <Row key={idx} className="mt-3">
                                                            <Col>
                                                                <Card style={{
                                                                    borderRadius: '15px',
                                                                    background: 'none',
                                                                    border: 'none',
                                                                }}
                                                                >
                                                                    <Card.Header
                                                                        style={{
                                                                            border: '1px solid #D9D9D9',
                                                                            background: 'none',
                                                                            borderTopLeftRadius: '15px',
                                                                            borderTopRightRadius: '15px',
                                                                            borderBottom: 'none'
                                                                        }}
                                                                    >
                                                                        <Row>
                                                                            <p style={{
                                                                                marginLeft: '16px',
                                                                                display: 'flex',
                                                                                alignItems: 'center'
                                                                            }}>
                                                                                <b>{cardItem.title.label + ' - ' + cardItem.title.value}</b>
                                                                            </p>
                                                                        </Row>
                                                                    </Card.Header>
                                                                    <Card.Body
                                                                        style={{
                                                                            border: '1px solid #D9D9D9',
                                                                            borderBottomLeftRadius: '15px',
                                                                            borderBottomRightRadius: '15px',
                                                                            borderTop: 'none'
                                                                        }}
                                                                    >
                                                                        <div className="-mt-3">
                                                                            {cardItem.ListLable.map((row, rindx) =>
                                                                                <Row
                                                                                    key={rindx}
                                                                                    className="mt-3"
                                                                                    style={{
                                                                                        marginLeft: '16px'
                                                                                    }}
                                                                                >
                                                                                    <Col
                                                                                        key={rindx}
                                                                                        lg={12}
                                                                                    >
                                                                                        <table
                                                                                            className="text-left"
                                                                                            style={{ width: '100%' }}
                                                                                        >
                                                                                            <tbody>
                                                                                                <tr key={idx}>
                                                                                                    <td style={{ width: '100%' }}>
                                                                                                        {/*<label>*/}
                                                                                                        <b>{row.label + ' :'}</b>
                                                                                                        {/*</label>*/}
                                                                                                    </td>
                                                                                                </tr>
                                                                                                <tr key={idx}>
                                                                                                    <td style={{ width: '100%' }}>{row.value}</td>
                                                                                                </tr>
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </Col>
                                                                                </Row>
                                                                            )}
                                                                        </div>
                                                                    </Card.Body>
                                                                </Card>
                                                            </Col>
                                                        </Row>
                                                    ))}
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            )
                        }
                        )}

                </div>
            }

            {/*More detail modal*/}
            <Modal isOpen={reportInfoModalData.isToggleModal} toggle={() => setReportInfoModalData({ isToggleModal: false })} size="lg" backdrop="static" keyboard={false}>
                <ModalHeader toggle={() => setReportInfoModalData({ isToggleModal: false })}>More Detail</ModalHeader>
                <ModalBody>
                    {reportInfoModalData.tableData !== undefined &&
                        reportInfoModalData.tableData.length !== 0 &&
                        reportInfoModalData.tableData.map((data: ModalData, index) => {
                            return (
                                <BorderGrid key={index}>
                                    <BorderGrid.Row>
                                        <BorderGrid.Col>
                                            <div>
                                                <label>{data.label}</label>
                                            </div>
                                            <div>
                                                <b>{data.value}</b>
                                            </div>
                                        </BorderGrid.Col>
                                    </BorderGrid.Row>
                                </BorderGrid>
                            )
                        })
                    }
                </ModalBody>
                <ModalFooter>
                    <Button variant="danger" onClick={() => setReportInfoModalData({ isToggleModal: false })}>Cancel</Button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    )
}

//ReportInformationMobileTable.defaultProps = {
//    isLoading: false,
//    listDataItem: []
//}

export default ReportInformationMobileTable